import { Button } from '@/components/ui/button';

import { WelletContext } from '@/context/wellet/welletContext';
import { approveRejectWorkData, getSalesCategorysNew } from '@/services';
import { Modal, Select, Toast } from '@/uiComponents/common';
import { defaultQueryOptions } from '@/utils/defaultQueryOptions';
import React, { useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { useSelector } from 'react-redux';

const ModalEvidences = ({
  isModalOpen,
  setIsModalOpen,
  pendingAction,
  t,
  setPendingAction,
  id,
  refetchStatus,
  i18n,
  handleSetValue,
  affiliateType,
}) => {
  const welletContext = useContext(WelletContext);
  const organization = useSelector((state) => state.app.selectedOrganization);
  const methods = useForm();

  const { data: allCategoriesData } = useQuery({
    queryKey: ['allCategories', organization.marketId, i18n.language],
    queryFn: () => getSalesCategorysNew(welletContext, organization.marketId),
    ...defaultQueryOptions,
  });
  const aprroveRejectMutation = useMutation({
    mutationFn: (body) => approveRejectWorkData(welletContext, organization.marketId, body),
    onSuccess: (_, variables) => {
      handleSetValue(variables?.workCredentialStatus);
    },
  });

  const handleConfirm = (data) => {
    let body = {
      userId: id,
      workCredentialStatus:
        pendingAction === 'approve'
          ? 'APPROVED'
          : pendingAction === 'revalidate'
          ? 'REVALIDATION'
          : 'REJECTED',
      salesCategoryId: data?.salesCategoryId ? data?.salesCategoryId?.value : null,
    };
    aprroveRejectMutation.mutate(body);
  };

  const handleCancel = () => {
    methods.reset({
      salesCategoryId: null,
    });
    setIsModalOpen(false);
    setPendingAction(null);
  };

  const salesCategoryFormatted = allCategoriesData?.data
    ?.filter((c) => c.schemeType === 'LOYALTY' && c.affiliateType === affiliateType)
    .map((ca) => ({
      label: `${ca.name} (${ca.defaultCommissionPercentage}%)`,
      value: ca.id,
      description: ca.defaultCommissionPercentage,
    }));

  return (
    <>
      {' '}
      <FormProvider {...methods}>
        <form>
          <Modal
            title={
              pendingAction === 'approve'
                ? t('approved.modal.title')
                : pendingAction === 'revalidate'
                ? t('revalidate.modal.title')
                : t('rejected.modal.title')
            }
            open={isModalOpen}
            onClose={handleCancel}
            isLoading={aprroveRejectMutation.isSuccess}
            maxWidth='600px'
            handleSubmit={methods.handleSubmit(handleConfirm)}
            customButtons={
              <>
                <div className='d-flex tw-gap-3 tw-mt-1 justify-content-end'>
                  <Button
                    variant='outline'
                    type='button'
                    onClick={handleCancel}
                    disabled={!aprroveRejectMutation.isIdle}
                  >
                    {t('cancel')}
                  </Button>
                  <Button
                    onClick={() => methods.handleSubmit(handleConfirm)()}
                    type='button'
                    disabled={!aprroveRejectMutation.isIdle}
                    className='tw-bg-black hover:tw-bg-black/90'
                  >
                    {t('confirm')}
                  </Button>
                </div>
              </>
            }
          >
            <div className='tw-text-black tw-mt-3'>
              {pendingAction === 'approve'
                ? t('approved.modal.text')
                : pendingAction === 'revalidate'
                ? t('revalidate.modal.text')
                : t('rejected.modal.text')}
            </div>
            <div className='tw-mt-1 tw-text-muted-foreground'>
              {pendingAction === 'approve'
                ? t('approved.modal.action')
                : pendingAction === 'revalidate'
                ? t('revalidate.modal.action')
                : t('rejected.modal.action')}
            </div>
            {pendingAction === 'approve' ? (
              <Select
                name={'salesCategoryId'}
                options={salesCategoryFormatted}
                isRequired={true}
                labelClassName={'!tw-text-black !tw-font-normal'}
                label={t('salesCategory.label')}
                className={'tw-mt-3 tw-w-1/2'}
              />
            ) : null}
          </Modal>
        </form>
      </FormProvider>
      {aprroveRejectMutation?.isSuccess ? (
        <Toast
          message={
            aprroveRejectMutation?.variables?.workCredentialStatus === 'APPROVED'
              ? t('approved.toast')
              : aprroveRejectMutation?.variables?.workCredentialStatus === 'REVALIDATION'
              ? t('revalidate.toast')
              : t('rejected.toast')
          }
          type={'SUCCESS'}
          onCallback={() => {
            aprroveRejectMutation.reset();
            setPendingAction(null);
            setIsModalOpen(false);
            refetchStatus();
          }}
        />
      ) : null}
      {aprroveRejectMutation?.isError ? (
        <Toast
          message={t('toast.error')}
          type={'ERROR'}
          onCallback={() => aprroveRejectMutation.reset()}
        />
      ) : null}
    </>
  );
};

export default ModalEvidences;
